"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapRest = exports.map = void 0;
var tslib_1 = require("tslib");
var getExcerptFromContentText = require("@wix/communities-blog-universal/dist/src/utils/get-excerpt-from-content-text");
var is_valid_url_1 = require("@wix/communities-blog-universal/dist/src/utils/is-valid-url");
var dateOf = function (date) { return ({
    $date: date.toISOString(),
}); };
var mapTimeToReadOf = function (post) {
    var WORD_REGEXP = /\S+/g;
    var WORDS_PER_MINUTE = 275;
    var wordCount = post.contentText.match(WORD_REGEXP) ? post.contentText.match(WORD_REGEXP).length : 0;
    return Math.ceil(wordCount / WORDS_PER_MINUTE);
};
var getPostImage = function (post) {
    if (!post.coverImage) {
        return {};
    }
    var _a = post.coverImage, id = _a.id, width = _a.width, height = _a.height;
    var hasImage = id && width && height;
    if (!hasImage) {
        return {};
    }
    return {
        coverImage: (0, is_valid_url_1.isValidUrl)(id) ? id : "wix:image://v1/" + id + "/" + id + "#originWidth=" + width + "&originHeight=" + height,
    };
};
var getPostPageUrl = function (post) { return (post.url ? { postPageUrl: post.url.path } : {}); };
var getExcerpt = function (post) {
    return post.excerpt ? { excerpt: post.excerpt } : { excerpt: getExcerptFromContentText(post.contentText) };
};
var mapRest = function (restPost) {
    var rpcPost = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, restPost), { firstPublishedDate: new Date(restPost.firstPublishedDate), lastPublishedDate: new Date(restPost.lastPublishedDate) });
    var rpcResult = map(rpcPost);
    return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, rpcResult), { publishedDate: new Date(rpcResult.publishedDate.$date), lastPublishedDate: new Date(rpcResult.lastPublishedDate.$date) });
};
exports.mapRest = mapRest;
var map = function (post) {
    var basePost = {
        _id: post.id,
        title: post.title,
        plainContent: post.contentText,
        publishedDate: dateOf(post.firstPublishedDate),
        viewCount: post.viewsCount,
        likeCount: post.likesCount,
        commentCount: post.commentsCount,
        lastPublishedDate: dateOf(post.lastPublishedDate || post.firstPublishedDate),
        coverImageDisplayed: post.isCoverImageDisplayed,
        timeToRead: mapTimeToReadOf(post),
        pinned: post.isPinned,
        featured: post.isFeatured,
        hashtags: post.hashtags,
        categories: post.categoryIds,
        tags: post.tagIds,
        author: post.contactId !== '' ? post.contactId : undefined,
    };
    var image = getPostImage(post);
    var url = getPostPageUrl(post);
    var excerpt = getExcerpt(post);
    return (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, basePost), image), url), excerpt);
};
exports.map = map;
//# sourceMappingURL=mapper.js.map